export default __webpack_public_path__ + "static/media/AckPrint.6e25c695.svg";